import { mdiBriefcaseOutline } from '@mdi/js';
import { MultiSelectCell } from '@pages/User/components';
import { ALL_CLASSES_OF_BUSINESS } from '@root/helpers/constants';
import type { CellContext, ColumnHelper, ColumnMeta } from '@tanstack/react-table';

export const classOfBusinessAccessor = <T extends { class_of_business?: string | string[] }>(
  columnHelper: ColumnHelper<T>,
  filterMeta: ColumnMeta<T, string>['filter'] = {},
) =>
  columnHelper.accessor((row) => row.class_of_business ?? [], {
    id: 'class_of_business',
    header: 'Class of Business',
    size: 192,
    minSize: 192,
    maxSize: 192,
    cell: (cellContext: CellContext<T, string | string[]>) => {
      const classValue = cellContext.getValue();
      const classes = Array.isArray(classValue) ? classValue : classValue ? [classValue] : [];
      const classItems = classes.map((className) => ({
        id: className,
        name: className,
      }));

      return (
        <MultiSelectCell
          entityName="Classes"
          entityNameSingular="Class"
          icon={mdiBriefcaseOutline}
          items={classItems}
          label="Class of Business"
          maxWidth="152px"
        />
      );
    },
    sortingFn: (a, b) => {
      const aValue = a.original.class_of_business;
      const bValue = b.original.class_of_business;

      const aClasses = Array.isArray(aValue) ? aValue : aValue ? [aValue] : [];
      const bClasses = Array.isArray(bValue) ? bValue : bValue ? [bValue] : [];

      const aFirst = aClasses[0];
      const bFirst = bClasses[0];

      // Handle undefined - push to end in ascending, beginning in descending
      if (!aFirst && !bFirst) return 0;
      if (!aFirst) return 1;
      if (!bFirst) return -1;

      return aFirst.localeCompare(bFirst);
    },
    meta: {
      headingCellClassName: 'w-44',
      isStandaloneDataCell: true,
      filter: {
        type: 'dropdown',
        placeholder: 'All classes',
        label: 'Class of Business',
        options: ALL_CLASSES_OF_BUSINESS,
        ...filterMeta,
      },
    },
    filterFn: 'arrIncludesSome',
  });
